import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import PageTitle from '@/components/v2/PageTitle.vue';
import DiyStepIndicator from '@/components/v2/DiyStepIndicator';
import ServiceBundlesManager from '@/components/v2/ServiceBundlesManager';
import ServiceBundleCard from '@/components/v2/ServiceBundleCard';
import ServiceBundleSelection from '@/plugins/graphql/mutations/v2/service-bundl-selection.gql';
import DiyRouterLeaveGuard from '@/helpers/vue_mixins/v2/DiyRouterLeaveGuard';
import TheLeaveConfirmationDialog from '@/components/v2/diy/TheLeaveConfirmationDialog';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import SegmentAnalyticsMixin from '@/helpers/vue_mixins/v2/SegmentAnalyticsMixin';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
let DiyBundleSelection = class DiyBundleSelection extends Mixins(DiyRouterLeaveGuard, ViewportSizeMixin, SegmentAnalyticsMixin, CleverTapEventsMixin) {
    async select(uuid) {
        let affiliateCode = null;
        let affiliateInviteLogUuid = null;
        const plan = this.$router.currentRoute.query.plan_type;
        const salesCode = this.$route.query.affiliate_code;
        if (salesCode) {
            const codes = salesCode.split(':');
            affiliateCode = codes[0];
            affiliateInviteLogUuid = codes[1];
        }
        await this.$apollo
            .mutate({
            mutation: ServiceBundleSelection,
            variables: {
                input: {
                    serviceBundleUuid: uuid,
                    plan,
                    affiliateCode,
                    affiliateInviteLogUuid,
                },
            },
        })
            .then((result) => {
            const bundle = result.data.serviceBundleSelection;
            const appUuid = bundle.app.uuid;
            const serviceBundleUuid = bundle.app.serviceBundle.uuid;
            const params = {
                serviceBundleUuid,
                appUuid,
                plan: plan,
                subsMonth: this.$router.currentRoute.query.subs_month,
            };
            this.allowNavigation();
            this.segmentTrack('DIY Step 1 - Bundle Selection', {
                bundle_name: bundle.app.serviceBundle.name,
            });
            this.onDIYSelectBundle(bundle.app.serviceBundle.name);
            this.$router.push({
                name: 'connect-your-facebook',
                params,
            });
        });
    }
    mounted() {
        this.viewDIYPage('Choose Service Bundle');
    }
};
DiyBundleSelection = __decorate([
    Component({
        components: {
            BaseOverlayLoader,
            DiyStepIndicator,
            ServiceBundlesManager,
            ServiceBundleCard,
            PageTitle,
            TheLeaveConfirmationDialog,
        },
    })
], DiyBundleSelection);
export default DiyBundleSelection;
